document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const money = (cents, format) => {
  const value = (Number(cents) / 100).toFixed(2);
  if (format && format.includes('{{amount_no_decimals}}')) return format.replace('{{amount_no_decimals}}', Math.round(Number(cents) / 100));
  if (format && format.includes('{{amount}}')) return format.replace('{{amount}}', value);
  return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', { style: 'currency', currency: window.themeCurrency || 'NZD' }).format(Number(cents) / 100);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-toggle]').forEach((button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;

    const setMenuState = (open) => {
      button.setAttribute('aria-expanded', String(open));
      const label = button.querySelector('[data-mobile-toggle-label]');
      if (label) label.textContent = open ? 'Close menu' : 'Open menu';
      panel.toggleAttribute('hidden', !open);
      document.body.classList.toggle('menu-open', open);
      if (open) panel.querySelector('a')?.focus();
    };

    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      setMenuState(!open);
    });

    panel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenuState(false));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const button = document.querySelector('[data-mobile-toggle][aria-expanded="true"]');
    if (button) {
      button.click();
      button.focus();
    }
  });

  const updateGallery = (scope, source) => {
    const gallery = scope?.querySelector?.('[data-product-gallery]')
      || (scope?.querySelector?.('[data-gallery-main]') ? scope : null);
    const main = gallery?.querySelector('[data-gallery-main]');
    if (!gallery || !main || !source?.image) return;

    main.src = source.image;
    if (source.srcset) main.srcset = source.srcset;
    else main.removeAttribute('srcset');
    if (source.sizes) main.sizes = source.sizes;
    main.alt = source.alt || '';
    if (source.mediaId) main.dataset.mediaId = source.mediaId;

    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    let matchingThumb = null;
    let matchingIndex = -1;
    thumbs.forEach((thumb, index) => {
      const current = Boolean(source.mediaId && thumb.dataset.mediaId === source.mediaId);
      thumb.setAttribute('aria-current', String(current));
      if (current) {
        matchingThumb = thumb;
        matchingIndex = index;
      }
    });
    const status = gallery.querySelector('[data-gallery-status]');
    if (status && matchingIndex >= 0) status.textContent = `${matchingIndex + 1} / ${thumbs.length}`;
    matchingThumb?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };

  const updateVariant = (radio, updateUrl = true) => {
    if (!radio?.checked) return;
    const picker = radio.closest('[data-variant-picker]');
    const scope = picker.closest('[data-product-scope]');
    const form = scope?.querySelector('form[action*="/cart/add"]');
    const input = form?.querySelector('input[name="id"]');
    const price = scope?.querySelector('[data-product-price]');
    const button = form?.querySelector('[type="submit"]');
    const detail = scope?.querySelector('[data-variant-detail]');

    if (input) input.value = radio.dataset.variantId;
    if (price) price.textContent = money(radio.dataset.price, price.dataset.moneyFormat);
    if (detail && radio.dataset.variantDetail) detail.textContent = radio.dataset.variantDetail;
    if (button) {
      const available = radio.dataset.available === 'true';
      button.disabled = !available;
      const label = button.querySelector('span');
      if (label) label.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
    }

    updateGallery(scope, {
      image: radio.dataset.mediaImage,
      srcset: radio.dataset.mediaSrcset,
      sizes: radio.dataset.mediaSizes,
      alt: radio.dataset.mediaAlt,
      mediaId: radio.dataset.mediaId
    });

    if (updateUrl && window.location.pathname.includes('/products/')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.dataset.variantId);
      window.history.replaceState({}, '', url.toString());
    }

    const liveRegion = document.getElementById('LiveRegion');
    if (liveRegion && updateUrl) {
      liveRegion.textContent = `${radio.dataset.variantTitle || 'Variant'} selected. ${price?.textContent || ''}`.trim();
    }
  };

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    picker.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => updateVariant(radio));
    });
    updateVariant(picker.querySelector('input[type="radio"]:checked'), false);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const showThumb = (index) => {
      if (!thumbs.length) return;
      const thumb = thumbs[(index + thumbs.length) % thumbs.length];
      updateGallery(gallery, {
        image: thumb.dataset.image,
        srcset: thumb.dataset.srcset,
        sizes: thumb.dataset.sizes,
        alt: thumb.dataset.alt,
        mediaId: thumb.dataset.mediaId
      });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showThumb(index));
    });

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
      const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
      showThumb((current < 0 ? 0 : current) - 1);
    });

    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
      const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
      showThumb((current < 0 ? -1 : current) + 1);
    });
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));
  } else {
    document.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }
});
